import { Ray, vec3 } from "./VectorMath.ts"

export interface Entity {
  /** Draw myself. */
  // draw(props: DrawProps): void

  /**
   * @param ray A ray in world space.
   * @returns An object describing where and when `ray` hits me, or `noHit` if it doesn't hit me.
   */
  hitTest(ray: Ray): Hit
}

export const nullEntity: Entity = {
  hitTest: (_ray) => noHit,
}

export type Hit = {
  /** The Entity that was hit. */
  who: Entity | null

  /** The time of the hit. This is the t parameter for `ray.at(t)`. */
  when: number

  /** The position of the hit. This is the result of `ray.at(t)`. */
  where: vec3

  /** An arbitrary extra value for use by the `Entity` that reported this `Hit`. */
  extra: any
}

export const noHit: Hit = {
  who: null,
  when: Infinity,
  where: vec3.infinity,
  extra: null
}
